export const AUTA_SPZ = [
  "9C2 8894",
  "1CA3338",
  "5C09767",
];
